<ion-header translucent mode='md'>
  <ion-toolbar>
    <ion-title>{{ 'checklistSelectorModal.modalTitle' | translate }}</ion-title>
    <ion-buttons slot='end'>
      <ion-button (click)='onDismiss()'>{{ 'checklistSelectorModal.closeButton' | translate }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content fullscreen>
  @for (checklist of checklists; track checklist) {
    <ion-button expand='block' type='submit' color='primary' (click)='buttonPressed(checklist)'>
      <ion-text color='light'>{{ checklist.description }}</ion-text>
    </ion-button>
  }
</ion-content>
